import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

// react-device-detect'in BrowserView/MobileView'i sadece user agent'a bakiyor.
// general.css ise 768px ve altinda #sidebar'i ekran disina itiyor; bu yuzden
// dar bir masaustu penceresinde (veya kendini masaustu gibi tanitan iPad'de)
// sidebar kayboluyor ve acma oku da onunla birlikte gizleniyordu.
// Burada cihaz mobilse VEYA pencere 768px ve altindaysa mobil gorunume geciyoruz.
// Esik general.css'teki @media (max-width: 768px) ile ayni olmali.
const MOBILE_QUERY = "(max-width: 768px)";

export const useMobileLayout = () => {
    const [isNarrow, setIsNarrow] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

    useEffect(() => {
        const mq = window.matchMedia(MOBILE_QUERY);
        const onChange = (e) => setIsNarrow(e.matches);
        mq.addEventListener("change", onChange);
        return () => mq.removeEventListener("change", onChange);
    }, []);

    return isMobile || isNarrow;
};

export const BrowserView = ({ children }) => (useMobileLayout() ? null : <>{children}</>);

export const MobileView = ({ children }) => (useMobileLayout() ? <>{children}</> : null);
